/**
 * @file     pageContent.ts
 * @purpose  Defines i18n-ready content schema for the blog listing page.
 */
import { localizedText, useResolvedContent } from '@/core/content';

const blogPageContentSchema = {
  hero: {
    eyebrow: localizedText('pages.blog.hero.eyebrow', 'Blog'),
    headline: localizedText('pages.blog.hero.headline', 'BC real estate, explained'),
    description: localizedText(
      'pages.blog.hero.description',
      'Short guides on buying, selling and the market.',
    ),
    startHere: localizedText('pages.blog.hero.startHere', 'Start here'),
  },
  crumbs: {
    home: localizedText('pages.blog.crumbs.home', 'Home'),
    blog: localizedText('pages.blog.crumbs.blog', 'Blog'),
  },
  categoriesLabel: localizedText('pages.blog.categoriesLabel', 'Topics'),
  filters: {
    all: localizedText('pages.blog.filters.all', 'All'),
    marketUpdate: localizedText('pages.blog.filters.marketUpdate', 'Market updates'),
    buyerGuide: localizedText('pages.blog.filters.buyerGuide', 'Buyer guides'),
    sellerGuide: localizedText('pages.blog.filters.sellerGuide', 'Seller guides'),
    presale: localizedText('pages.blog.filters.presale', 'Presale'),
    neighbourhood: localizedText('pages.blog.filters.neighbourhood', 'Neighbourhoods'),
  },
  emptyState: localizedText(
    'pages.blog.emptyState',
    'No articles in this category yet.',
  ),
  emptyAction: localizedText('pages.blog.emptyAction', 'See every article'),
  crossSell: {
    title: localizedText(
      'pages.blog.crossSell.title',
      'Plan your next move',
    ),
    description: localizedText(
      'pages.blog.crossSell.description',
      'Answer a few questions to get a next step.',
    ),
  },
  provenance: localizedText(
    'pages.blog.provenance',
    'BCRES MLS® and BC Government figures, cited in each post',
  ),
};

export const useBlogContent = () =>
  useResolvedContent(blogPageContentSchema);
